import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'centPrice'
})
export class CentPricePipe implements PipeTransform {

    transform(value: string | number): string {
        if (!value) {
            return '00';
        }
        const valueString = String(value);
        return valueString.includes('.') ? valueString.split('.')[1].padEnd(2, '0') : '00';
    } // transform()

} // CentPricePipe
